import axios from 'axios'
import config from '../config'

export default {

    getNotifications() {
        return axios.get(config.publicPath + 'notifications', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    markNotificationAsRead(id) {
        return axios.put(config.publicPath + 'notifications/' + id);
    }
}
